// External store so FloatingLanguageToggle can tell whether a PublicReport
// is currently mounted (public report page renders its own inline toggle in the
// header and doesn't need the floating one). Avoids visual overlap between the
// floating toggle and the download buttons in the header (ENG-138, Task 9).
let mounted = false
const listeners = new Set<() => void>()

export const publicReportPagePresence = {
  subscribe(cb: () => void) {
    listeners.add(cb)
    return () => { listeners.delete(cb) }
  },
  getSnapshot() {
    return mounted
  },
  set(value: boolean) {
    if (mounted === value) return
    mounted = value
    listeners.forEach((l) => l())
  },
}
